import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import SelectableEntity from '@/models/Shared/SelectableEntity'
import AvailabilityRestrictionSummary from '../AvailabilityRestrictions/AvailabilityRestrictionSummary';

export default class BookingBrowseWorkersViewModel {
    bookingRoleId: string;
    workerProfiles: SelectableEntity<WorkerProfileDto>[] = [];
    selectedWorkerId = "";
    selectedWorkerIds: string[] = [];
    selectedWorker: WorkerProfileDto = new WorkerProfileDto();
    workersForQuickBook: WorkerProfileDto[] = [];
    selectedWorkerForQuickBook: WorkerProfileDto = new WorkerProfileDto();
    payRateForQuickBook = 0;
    minimumPayRateForQuickBook = 0;
    availabilitySummariesForQuickbook: AvailabilityRestrictionSummary[] = [];
}